"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _SessionNew = _interopRequireDefault(require("../model/SessionNew"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Sessions service.
* @module api/SessionsApi
* @version 1.0.0
*/
var SessionsApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SessionsApi. 
  * @alias module:api/SessionsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SessionsApi(apiClient) {
    _classCallCheck(this, SessionsApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * create session
   * @param {Object} opts Optional parameters
   * @param {String} opts.email email
   * @param {String} opts.passwordDigest password_digest
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SessionNew} and HTTP response
   */


  _createClass(SessionsApi, [{
    key: "apiV1SessionsPostWithHttpInfo",
    value: function apiV1SessionsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'email': opts['email'],
        'password_digest': opts['passwordDigest']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SessionNew.default;
      return this.apiClient.callApi('/api/v1/sessions', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * create session
     * @param {Object} opts Optional parameters
     * @param {String} opts.email email
     * @param {String} opts.passwordDigest password_digest
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SessionNew}
     */

  }, {
    key: "apiV1SessionsPost",
    value: function apiV1SessionsPost(opts) {
      return this.apiV1SessionsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return SessionsApi;
}();

exports.default = SessionsApi;